import { addDoc, collection, doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

// No-login coach links for rooming and teams. The coachLinks doc ID is the
// token; Cloud Functions mirror the tour's rooms/teams + names onto it and copy
// the coach's edits back (see functions/coachLinks.js).

export const PORTAL_ORIGIN = 'https://msttoursportal.co.uk';

const PATHS = { rooming: '/rooming-assignment', teams: '/teams-assignment' };

export function coachLinkUrl(kind, token) {
  return `${PORTAL_ORIGIN}${PATHS[kind]}?token=${token}`;
}

export async function createCoachLink({ requestId, kind, user }) {
  const ref = await addDoc(collection(db, 'coachLinks'), {
    requestId,
    kind,
    revoked: false,
    createdAt: serverTimestamp(),
    createdBy: user?.email || '',
  });
  return ref.id;
}

/** True if a token is a live link for this tour (legacy rooming tokens aren't). */
export async function isLiveCoachLink(token, requestId) {
  if (!token) return false;
  try {
    const snap = await getDoc(doc(db, 'coachLinks', token));
    return snap.exists() && !snap.data().revoked && snap.data().requestId === requestId;
  } catch {
    return false;
  }
}

export function revokeCoachLink(token) {
  return updateDoc(doc(db, 'coachLinks', token), { revoked: true, revokedAt: serverTimestamp() });
}
